<h2 mat-dialog-title>Mass Update</h2>

<mat-dialog-content fxLayoutAlign="space-around center">
    <busy-indicator *ngIf="!isLoaded"></busy-indicator>

    <div class="massUpdateContainer" *ngIf="isLoaded" [formGroup]="formGroup">
        <div formArrayName="properties" fxLayout="row">
            <div *ngFor="let property of metadata.Properties; index as i" class="property">
                <lgd-checkbox fxFlex="15" controlName="{{i}}">
                </lgd-checkbox>
                <form>
                    <metadata-input ngModelGroup="{{property.Name}}_muGroup" fxFlex="85" [metadata]="metadata"
                                    [field]="property.Name" [metadataModel]="property" [viewOnly]="!canEdit(property)">
                    </metadata-input>
                </form>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="onCloseClick()" telemetry="Submission-MassUpdateCancel">
        Cancel
    </button>

    <button mat-button [disabled]="!CanUpdate" (click)="onUpdateClick()" telemetry="Submission-MassUpdateConfirm">
        Update
    </button>
</mat-dialog-actions>
